import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { TextField } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  asterisk: { color: '#f44336' },
  autocomplete: {
    '& .MuiFilledInput-root .MuiAutocomplete-input': {
      padding: '10px 4px 10px 6px'
    },
    '& .MuiFilledInput-underline:before, & .MuiFilledInput-underline:after': {
      display: 'none'
    }
  }
}))

function SearchableSelectField({ items = [], value: valueProp = '', onChange, disabled, required, error, helperText, label, size = 'small' }) {
  const classes = useStyles()
  const selectedOption = items.find(o => o.value === valueProp) || null

  function handleChange(_, option) {
    onChange && onChange({ target: { value: option ? option.value : '' } })
  }

  return (
    <Autocomplete
      className={classes.autocomplete}
      style={{ width: '100%' }}
      options={items}
      getOptionLabel={(o) => o.text || ''}
      getOptionSelected={(opt, val) => opt?.value === val?.value}
      value={selectedOption}
      onChange={handleChange}
      disabled={disabled}
      noOptionsText='No results'
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          label={label}
          required={required}
          helperText={helperText}
          error={error}
          size={size}
          variant='filled'
          InputLabelProps={{
            ...params.InputLabelProps,
            classes: {
              root: 'ng-form-control-label',
              focused: 'ng-form-control-label-filled-focused',
              error: 'ng-form-control-label-error',
              asterisk: classes.asterisk
            }
          }}
          InputProps={{
            ...params.InputProps,
            classes: {
              root: `ng-form-control${label ? '' : ' no-label'}`,
              underline: 'ng-form-control-filled',
              focused: 'ng-form-control-filled-focused',
              error: 'ng-form-control-filled-error'
            },
            style: { backgroundColor: '#ffffff', border: '1px solid #5f5753', borderRadius: 4 },
            disableUnderline: true
          }}
        />
      )}
    />
  )
}

export default SearchableSelectField
